<template>
  <section class="summary tw-bg-grey-100 tw-mb-1 tw-relative tw-z-10">
    <img
      :src="`${data.sidebarContent.lotImage}`"
      class="lot-image"
      :class="{ 'tw-opacity-25': loading }"
      alt=""
    />
    <div id="summary">
      <h2
        v-if="
          data.sidebarContent.headlinePrefix ||
            data.sidebarContent.headlineLotName
        "
        class="headline--single-line headline--condensed tw-text-l tw-mb-2"
      >
        <span class="text-red"
          >{{ data.sidebarContent.headlinePrefix }}
          {{ data.sidebarContent.headlineLotName }}</span
        >
      </h2>
      <ul
        class="summary-configuration"
        data-qa="Checkout_Configurator_Value_WinningCategories"
      >
        <li
          v-for="(drawing, index) in drawingWinningCategory"
          :key="index"
          :data-qa="
            drawing.name == 'Zusatzspiel'
              ? 'Checkout_Configurator_Value_FeatureGame'
              : null
          "
          class="tw-mb-1"
        >
          <div
            class="summary-list__check"
            :class="{ 'is-selected': hasSelectedLevel(drawing) }"
          >
            <a
              :href="'#' + $formatAnchor(drawing.name)"
              class="tw-w-full tw-flex"
              :class="{ 'option-available': !hasSelectedLevel(drawing) }"
            >
              <div class="tw-flex tw-items-center tw-mr-1">
                <!-- <span class="tw-text-grey-500 tw-mr-2 tw-underline sm:tw-hidden tw-whitespace-no-wrap" v-if="!hasSelectedLevel(drawing)">
                  Option wählen
                </span> -->
                <span
                  class="check-circle tw-flex-grow-0 tw-rounded-full tw-flex-shrink-0 tw-relative tw-text-white"
                  :class="{
                    'is-checked tw-icon tw-icon-haken': hasSelectedLevel(
                      drawing
                    )
                  }"
                ></span>
              </div>
              <div class="tw-items-center tw-flex tw-flex-wrap">
                <span
                  class="tw-text-m"
                  :class="{
                    'font-bold': hasSelectedLevel(drawing)
                  }"
                >
                  <template v-if="jahreslosData">
                    {{ data.sidebarContent.jahreslosCategoryText }}
                  </template>
                  <template v-else>
                    <span>{{
                      hasSelectedLevel(drawing) ? drawing.drawingsPerMonth : 0
                    }}</span>
                    <span>&nbsp;×&nbsp;</span>
                    <span>{{ drawing.name }}</span>
                    <span v-if="hasSelectedLevel(drawing)"
                      >&nbsp;pro Monat</span
                    >
                  </template>
                </span>
              </div>
            </a>
          </div>
        </li>
      </ul>
      <div v-if="isBlackWeekActive" class="black-week__banner tw-bg-green-150">
          Los kaufen, Gratis-Los sichern und an 10 Ziehungen im April teilnehmen.
      </div>
      <ul
        class="configurator__summary__infoblock tw-text-m tw-mb-2"
        aria-atomic="true"
        data-qa="Configurator_SummaryBox_ContentContainer_ParticipationSummary"
      >
        <li
          class="summary-list__item"
          data-qa="Configurator_SummaryBox_Value_PlayingStartDate"
        >
          <span class="font-bold"
            >{{ data.sidebarContent.playingDateLabel }}
          </span>
          <span data-qa="Checkout_Configurator_Value_PlayingDate">
            <template v-if="jahreslosData && !data.lotType">
              <a href="#LotType">{{
                data.sidebarContent.playingDatePleaseSelectValue
              }}</a>
            </template>
            <template v-else-if="playingDate === PlayingDateUnspecified">
              Wählt der Beschenkte
            </template>
            <template v-else>
              {{ $formatDate(playingDate, 'de-DE') }}
            </template>
          </span>
        </li>

        <li
          v-if="!jahreslosData"
          class="summary-list__item tw-relative"
          data-qa="Configurator_SummaryBox_Value_Cancellation"
        >
          <transition
            enter-class="tw-opacity-0"
            enter-active-class="tw-transition-all tw-duration-300"
            leave-active-class="tw-transition-all tw-duration-300"
            leave-to-class="tw-opacity-0"
          >
            <div
              class="tw-absolute tw-z-10 tool-tip"
              v-show="showCancellationPolicyTip"
              v-if="
                showCancellationAndRuntimeTips &&
                  data.sidebarContent.cancellationPolicyHint
              "
            >
              <tipp direction="bottom-left" :info="true" :bold="false">
                <template #default>
                  <span
                    v-html="data.sidebarContent.cancellationPolicyHint"
                  ></span>
                </template>
              </tipp>
            </div>
          </transition>
          <span class="font-bold">{{
            data.sidebarContent.cancellationPolicyLabel
          }}</span
          ><span>
            {{ data.sidebarContent.cancellationPolicyMonthlyValue }}
          </span>
          <button
            class="tw-px-1/2 tw-py-1 md:tw-p-0 md:tw-ml-1/2 info-button tw-absolute tw-top-1/2 tw-rounded-full tw-h-2 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-solid-white focus-visible:tw-outline-offset-2 focus-visible:tw-shadow-ring"
            v-if="
              showCancellationAndRuntimeTips &&
                data.sidebarContent.cancellationPolicyHint
            "
            @click="
              showCancellationPolicyTip ||
                trackClick(
                  `pk_lotterie_konfi_dein-los_icon_bedingungen_kuendbar-monatlich`
                );
              showRuntimeTip = false;
              showCancellationPolicyTip = !showCancellationPolicyTip;
            "
            aria-label="weitere Informationen zur Kündigung"
          >
            <span
              class="tw-icon tw-icon-information-bold tw-rounded-full tw-border tw-border-solid tw-border-grey-800 tw-relative sidebar-tooltip-icon"
              :class="{
                'tw-bg-grey-800 tw-text-white': showCancellationPolicyTip
              }"
            ></span>
          </button>
        </li>

        <li
          v-if="jahreslosData && this.data.lotFormat === 'HighQualityPrinted'"
          class="summary-list__item"
          data-qa="Configurator_SummaryBox_Value_DurationLimitation"
        >
          <span class="font-bold"
            >{{ data.sidebarContent.shippingDateLabel }} </span
          ><span>{{ $formatDate(this.$props.shippingDate, 'de-DE') }}</span>
        </li>

        <li
          class="summary-list__item tw-relative"
          data-qa="Configurator_SummaryBox_Value_DurationLimitation"
        >
          <transition
            enter-class="tw-opacity-0"
            enter-active-class="tw-transition-all tw-duration-300"
            leave-active-class="tw-transition-all tw-duration-300"
            leave-to-class="tw-opacity-0"
          >
            <div
              class="tw-absolute tw-z-10 tool-tip"
              v-show="showRuntimeTip"
              v-if="showCancellationAndRuntimeTips && lotDurationHint"
            >
              <tipp direction="bottom-left" :info="true" :bold="false">
                <template #default>
                  <span v-html="lotDurationHint"></span>
                </template>
              </tipp>
            </div>
          </transition>
          <span class="font-bold">{{ data.sidebarContent.runtimeLabel }} </span
          ><span>{{ lotDuration }}</span>

          <button
            class="tw-px-1/2 tw-py-1 md:tw-p-0 md:tw-ml-1/2 info-button tw-absolute tw-top-1/2 tw-rounded-full tw-h-2 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-solid-white focus-visible:tw-outline-offset-2 focus-visible:tw-shadow-ring"
            v-if="showCancellationAndRuntimeTips && lotDurationHint"
            @click="
              showRuntimeTip ||
                trackClick(
                  `pk_lotterie_konfi_dein-los_icon_bedingungen_laufzeit-${
                    data.lotDuration === LotDuration.OneYear
                      ? '1jahr'
                      : 'unbefristet'
                  }`
                );
              showCancellationPolicyTip = false;
              showRuntimeTip = !showRuntimeTip;
            "
            aria-label="weitere Informationen zur Laufzeit"
          >
            <span
              class="tw-icon tw-icon-information-bold tw-rounded-full tw-border tw-border-solid tw-border-grey-800 tw-relative sidebar-tooltip-icon"
              :class="{ 'tw-bg-grey-800 tw-text-white': showRuntimeTip }"
            ></span>
          </button>
        </li>

        <li class="summary-list__item">
          <span class="font-bold">{{
            data.sidebarContent.shippingTargetLabel
          }}</span>
          <span v-if="jahreslosData && !data.lotFormat"
            ><a href="#LotFormat">
              {{ data.sidebarContent.shippingTargetPleaseSelectValue }}
            </a>
          </span>
          <span v-else>{{ lotFormatText }}</span>
        </li>
      </ul>
      <div class="tw-mb-2" v-if="getSmallBanner()">
        <div class="tw-w-full tw-flex tw-bg-orange-100 tw-rounded-md tw-p-1">
          <p v-html="getSmallBanner()"></p>
        </div>
      </div>

      <div
        v-if="
          this.$props.validationData &&
            this.isNewUser &&
            !getSmallBanner() &&
            !this.data.editModeEnabled
        "
      >
        <div
          class="tw-mb-2 tw-bg-form-primary-bg tw-rounded-md tw-p-1"
          v-if="isValidCode && showValidationMessage"
        >
          {{ this.$props.validationData.successMessage }}
        </div>
        <div class="tw-mb-2" v-else-if="isValidCode && !showValidationMessage">
          <error-message
            :headline="this.$props.validationData.invalidMessage"
          />
        </div>
        <div class="tw-mb-2" v-else-if="!isValidCode">
          <error-message
            :headline="this.$props.validationData.invalidMessage"
          />
        </div>
      </div>

      <div>
        <div class="configurator__summary__sum" ref="pricing">
          <tipp
            v-if="!data.editModeEnabled && boosterTipp && !disabled"
            direction="bottom-left"
            emphasize
            :bold="false"
          >
            <template #default>
              <span v-html="boosterTipp"></span>
            </template>
          </tipp>
          <div
            class="tw-relative tw-h-input"
            v-if="!data.editModeEnabled && boosterData && !disabled"
            @mousedown.capture="trackLotQuantityClick"
            @touchstart.capture="trackLotQuantityClick"
          >
            <select
              v-model="selectedLotCount"
              id="lotCountSelect"
              @input="
                lotQuantitySelectIsOpen &&
                  trackClick(
                    `pk_lotterie_5s-ob-konfi_anzahl-lose_auswahl_${$event.target.value}`
                  );
                lotQuantitySelectIsOpen = false;
              "
              @blur="lotQuantitySelectIsOpen = false"
              class="select tw-absolute tw-w-full tw-left-0 tw-top-0 tw-h-full tw-opacity-0"
            >
              <option v-for="count in lotCounts" :key="count" :value="count">
                {{ count }}
              </option>
            </select>

            <label
              for="lotCountSelect"
              class="tw-relative tw-pointer-events-none tw-block tw-flex tw-items-center tw-h-full tw-border tw-border-grey-800 tw-appearance-none font-bold tw-px-2 tw-pr-4 tw-mt-1 tw-w-full"
            >
              {{ boosterData.lotQuantityDropdownLabel }} {{ selectedLotCount }}

              <span
                class="tw-icon tw-icon-weiter-down-bold tw-absolute tw-top-1/2 tw-transform tw--translate-y-1/2 tw-right-0 tw-mr-1 tw-text-l"
              ></span>
            </label>
          </div>
          <p
            v-if="selectedLevels.length > 0"
            class="tw-flex tw-justify-between tw-items-end font-bold"
          >
            <span class="configurator__summary__sum__monthly-payment__label">
              {{
                data.lotDuration === LotDuration.Unlimited
                  ? data.sidebarContent.priceLabelRecurringValue
                  : data.sidebarContent.priceLabelOneTimeValue
              }}
            </span>
            <span
              class="configurator__summary__sum__price-container tw-flex tw-items-baseline tw-text-l tw-flex-grow"
            >
              <span class="configurator__summary__sum__monthly-payment__value">
                {{ sumPrice }}
              </span>
              <span class="">{{ '\xa0' }}<abbr title="Euro">€</abbr></span>
              <span class="">{{ '\xa0' }}*</span>
            </span>
          </p>
          <div v-else>
            <strong>{{ data.sidebarContent.noCategorySelectedLabel }}</strong>
          </div>

          <div class="tw-mb-3" v-if="monthlyDrawings > 0">
            {{ monthlyDrawings }} Ziehungen
          </div>
          <div
            class="tw--mx-4 tw-mb-2"
            v-if="data.countdown && data.countdown.showInSidebar"
          >
            <Countdown
              :date="data.countdown.date"
              :pluralDayText="data.countdown.dayText"
              :slideText="data.countdown.sidebarBannerText"
              :postfixText="data.countdown.trailingText"
              :backgroundColor="data.countdown.color"
            ></Countdown>
          </div>
        </div>

        <template v-if="data.editModeEnabled">
          {{ /* Edit Mode */ }}
          <btn
            :disabled="disabled"
            :rounded="true"
            class="tw-mr-0 tw-mb-1"
            @click.prevent="finishEdit"
            data-qa="Checkout_Configurator_Button_ProceedToShoppingCart"
          >
            {{ data.sidebarContent.editModeProceedLabel }}
          </btn>

          <btn
            :disabled="disabled"
            secondary
            :rounded="true"
            class="tw-mr-0 tw-mb-1"
            @click.prevent="cancelEdit"
            data-qa="Checkout_Configurator_Button_Cancel"
          >
            {{ data.sidebarContent.editModeCancelLabel }}
          </btn>
        </template>

        <template v-else>
          {{ /* Default */ }}
          <btn
            :disabled="disabled"
            :rounded="true"
            class="tw-mr-0 tw-mb-2 summary__button"
            data-qa="Checkout_Configurator_Button_ProceedToShoppingCart"
            @click.prevent="
              trackClick('pk_click_add_cart_konfi');
              trackAddProduct('add_to_cart');
              proceedToShoppingcart();
            "
          >
            {{ data.sidebarContent.proceedToShoppingLabel }}
          </btn>
          <btn
            :disabled="disabled"
            :rounded="true"
            :secondary="true"
            class="tw-mr-0 tw-mb-1 summary__secondary-button"
            data-qa="Checkout_Configurator_Button_ProceedToCheckout"
            @click.prevent="
              trackClick('pk_click_add_checkout_konfi');
              trackAddProduct('add_to_checkout');
              proceedToCheckout();
            "
          >
            {{ data.sidebarContent.proceedToCheckoutCartLabel }}
          </btn>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { cancelEdit, finishEdit } from '../services/edit-mode-service';
import {
  proceedToCarddesign,
  proceedToCheckout,
  proceedToLotChange,
  proceedToShoppingcart
} from '../services/proceed-service';
import { LotDuration } from '@/constants';
import Countdown from './Countdown.vue';
import { showCancellationAndRuntimeTips } from '@/main';
import { getLotDates } from '../services/lotnumber-service';
import ErrorMessage from '@/components/LotnumberPicker/ErrorMessage.vue';

export default {
  name: 'Summary',
  components: {
    ErrorMessage,
    Countdown
  },
  props: {
    drawing: Array,
    playingDate: String,
    shippingDate: String,
    lotFormat: String,
    loading: Boolean,
    validationData: Object
  },
  data() {
    return {
      lotQuantitySelectIsOpen: false,
      summaryInViewport: false,
      selectedLotCount: 1,
      showCancellationPolicyTip: false,
      showRuntimeTip: false,
      showCancellationAndRuntimeTips,
      totalAmount: 0
    };
  },
  mounted() {
    getLotDates(this.data.product).then((lotDates) => {
      if (lotDates.data) {
        this.data.shippingDate = new Date(lotDates.data.ShippingDate);
        this.data.playingDate = new Date(lotDates.data.PlayingDate);
      }
    });

    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.summaryInViewport = true;
        } else {
          this.summaryInViewport = false;
        }
      });
    });

    this.intersectionObserver.observe(this.$refs.pricing);
  },
  computed: {
    disabled() {
      return !this.drawingWinningCategory.find(
        (drawing) =>
          drawing.name !== 'Zusatzspiel' && this.hasSelectedLevel(drawing)
      );
    },
    selectedLevels() {
      return this.drawingWinningCategory.reduce((selectedLevels, drawing) => {
        const selectedLevel = drawing.levels.find((level) => level.isSelected);
        if (selectedLevel) {
          selectedLevels.push(selectedLevel);
        }
        return selectedLevels;
      }, []);
    },
    monthlyDrawings() {
      if (this.data.product !== 'JL') {
        return this.drawingWinningCategory
          .filter((drawing) => this.hasSelectedLevel(drawing))
          .reduce((count, drawing) => count + drawing.drawingsPerMonth, 0);
      } else {
        return '12';
      }
    },
    isNewUser() {
      return window.utag_data && window.utag_data['cp.utag_main_am_gratis'];
    },
    sumPrice() {
      let price = this.selectedLevels.reduce(
        (price, level) => price + level.price,
        0
      );

      price *= this.selectedLotCount;

      return this.$formatPrice(price);
    },
    isValidCode() {
      return this.$props.validationData && this.$props.validationData.valid;
    },
    showValidationMessage() {
      if (this.isValidCode) {
        if (this.data.editModeEnabled) {
          return this.data.IsCouponCodeValid;
        }

        return (
          this.$props.validationData.minimumCartValue <=
          parseFloat(this.sumPrice)
        );
      }

      return false;
    },
    showSummaryHint() {
      return ['xs', 'sm'].includes(this.$bp.name) && !this.summaryInViewport;
    },
    drawingWinningCategory() {
      return this.drawing.filter(
        (drawing) => drawing.type == 'WinningCategory'
      );
    },
    lotFormatText() {
      if (this.lotFormat === 'Pdf') {
        return this.data.sidebarContent.shippingTargetPdfValue;
      } else {
        return this.data.sidebarContent.shippingTargetPrintedValue;
      }
    },
    boosterTipp() {
      if (!this.boosterData || !this.boosterData.htmlLotQuantityTipText) {
        return;
      }

      if (this.selectedLotCount > 1) {
        return;
      }

      return this.$interpolate(this.boosterData.htmlLotQuantityTipText, {
        number: this.monthlyDrawings * (this.selectedLotCount + 1)
      });
    },
    lotCounts() {
      return (
        this.boosterData &&
        Array.from({ length: this.boosterData.lotQuantity }, (_, i) => i + 1)
      );
    },
    checkoutConfiguration() {
      const configuration = this.getConfiguration();
      configuration.lotQuantity = this.selectedLotCount;
      return configuration;
    },
    lotDuration() {
      if (this.jahreslosData && this.data.lotDuration === LotDuration.OneYear) {
        return this.data.sidebarContent.runtimeLimitedValue;
      }

      return this.data.sidebarContent.runtimeUnlimitedValue;
    },
    lotDurationHint() {
      if (this.jahreslosData && this.data.lotDuration === LotDuration.OneYear) {
        return this.data.sidebarContent.runtimeLimitedHint;
      }

      return this.data.sidebarContent.runtimeUnlimitedHint;
    },
    isBlackWeekActive() {
      const now = new Date();
      const currentDay = now.getDate();
      const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11
      const currentYear = now.getFullYear();

      const config = this.checkoutConfiguration;

      // Check if it's March 2026 and the item meets the type conditions
      return (
        currentDay >= 2 && currentDay < 16 && currentMonth === 3 && currentYear === 2026 && config.product === 'MGL'
      );
    }
  },
  methods: {
    getSmallBanner() {
      return this.$options.filters.capitalize(
        this.data.svlData?.Texts?.SmallBannerBk || this.data.svlData?.Texts?.SmallBanner || ''
      );
    },
    getSelectedLevelWinningAmount(drawing) {
      let selectedLevel = drawing.levels.find((level) => level.isSelected);
      if (
        selectedLevel.oneTimeWinningSum === 0 ||
        selectedLevel.oneTimeWinningSum === null
      ) {
        return this.$formatPrice(selectedLevel.monthlyWinningSum, false);
      }
      return this.$formatPrice(selectedLevel.oneTimeWinningSum, false);
    },
    hasSelectedLevel(drawing) {
      return !!drawing.levels.find((level) => level.isSelected);
    },
    finishEdit() {
      this.$emit('validate-form', async (ok) => {
        if (!ok) {
          return;
        }
        this.$emit('loading');
        const result = await finishEdit(this.checkoutConfiguration);

        if (result.success) {
          window.location.href = result.data.redirectUrl;
          return;
        } else {
          this.$emit('error', result);
        }

        this.$emit('done');
      });
    },
    async cancelEdit() {
      this.$emit('loading');
      const result = await cancelEdit();

      if (result.success) {
        window.location.href = result.data.redirectUrl;
        return;
      } else {
        this.$emit('error', result);
      }
      this.$emit('done');
    },
    proceedToCheckout() {
      this.$emit('validate-form', async (ok) => {
        if (!ok) {
          return;
        }
        this.$emit('loading');
        const result = await proceedToCheckout(this.checkoutConfiguration);

        if (result.success) {
          window.location.href = result.data.redirectUrl;
          return;
        } else {
          this.$emit('error', result);
        }

        this.$emit('done');
      });
    },
    hideAllTips() {
      this.showCancellationPolicyTip = false;
      this.showRuntimeTip = false;
    },
    async proceedToShoppingcart() {
      this.$emit('validate-form', async (ok) => {
        if (!ok) {
          return;
        }
        this.$emit('loading');
        const result = await proceedToShoppingcart(this.checkoutConfiguration);

        if (result.success) {
          window.location.href = result.data.redirectUrl;
          return;
        } else {
          this.$emit('error', result);
        }

        this.$emit('done');
      });
    },
    async proceedToCarddesign() {
      this.$emit('validate-form', async (ok) => {
        if (!ok) {
          return;
        }

        this.$emit('loading');
        const result = await proceedToCarddesign(this.getConfiguration());

        if (result.success) {
          window.location.href = result.data.redirectUrl;
          return;
        } else {
          this.$emit('error', result);
        }

        this.$emit('done');
      });
    },
    async proceedToLotChange() {
      this.$emit('validate-form', async (ok) => {
        if (!ok) {
          return;
        }
        this.$emit('loading');
        const result = await proceedToLotChange(this.checkoutConfiguration);

        if (result.success) {
          window.location.href = result.data.redirectUrl;
          return;
        } else {
          this.$emit('error', result);
        }

        this.$emit('done');
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../sass/mixins';

.configurator {
  &__summary {
    &__infoblock {
      @apply tw-mb-2;

      .summary-list__item a:focus-visible {
        outline: 0.125rem solid theme('colors.white');
        outline-offset: 0.125rem;
        @apply tw-shadow-ring;
      }
    }

    &__sum {
      &__price-container {
        &:before {
          content: '';
          @apply tw-inline-block tw-w-full;
          border-bottom: px-to-rem(1px) dotted theme('colors.grey.300');
        }

        abbr[title] {
          @apply tw-no-underline;
        }
      }
    }
  }
}

.summary {
  padding: px-to-rem(84px) px-to-rem(32px) px-to-rem(24px) px-to-rem(32px);
  @apply tw-rounded-2xl tw-text-grey-800;
  margin-top: px-to-rem(60px);

  @media (max-width: theme('screens.sm')) {
    max-width: 100%;
    padding-left: px-to-rem(16px);
    padding-right: px-to-rem(16px);
    border-radius: px-to-rem(0px);
  }

  &-configuration {
    padding-bottom: px-to-rem(16px);
  }

  &-list {
    &__item {
      line-height: px-to-rem(21px);
      margin-bottom: px-to-rem(8px);

      &:last-child {
        @apply tw-mb-0;
      }
    }

    &__check {
      a {
        @apply tw-no-underline;
      }

      &.is-checked {
        @apply tw-text-grey-800;
      }
    }
  }
  .black-week__banner {
  font-size: 11px;
  padding: 5px 10px;
  margin: 0 -10px 16px -10px;
  font-family: "Aktion Mensch Bold", sans-serif;
  line-height: 16px;
  }
}

li:last-child .summary-list__check {
  @apply tw-mb-0;
}

.check-circle {
  width: px-to-rem(24px);
  height: px-to-rem(24px);
  @apply tw-border tw-border-grey-800;

  &::before {
    font-size: px-to-rem(24px);
    @apply tw-relative;
    left: px-to-rem(-1px);
  }

  &.is-checked {
    @apply tw-border-green-500 tw-bg-green-500;
  }
}

.info-button {
  @apply tw-transform tw--translate-y-1/2;
}

.tool-tip {
  bottom: px-to-rem(22px);
}

.sidebar-tooltip-icon {
  top: px-to-rem(-2px);
}

.select:focus + label {
  @apply tw-border-2;
}

select.select {
  @apply tw-block tw-visible;
}

.headline--single-line {
  line-height: px-to-rem(36px);
}

button.tw-text-base {
  display: block;
  padding: px-to-rem(8px) px-to-rem(24px);
  line-height: px-to-rem(32px);
  font-size: px-to-rem(20px);
  max-width: px-to-rem(285px);

  &.summary__secondary-button {
    max-width: px-to-rem(210px);
  }

  @media (max-width: theme('screens.sm')) {
    max-width: 100%;

    &.summary__secondary-button {
      max-width: 100%;
    }
  }
}
</style>
